export const rhiticsPageNames = ['home', 'login', 'logout', 'denied', 'forget_password', 'profile', 'account'] as const

export type RhiticsPageName = typeof rhiticsPageNames[number]

const isInProduction = process.env.NODE_ENV === 'production'

export function toRhitics(name: RhiticsPageName, subPageName?: string): void {
  const isDirectToHome = name === 'home'
  const host = process.env.VUE_APP_WEBSITE_DOMAIN

  const baseUrl = isInProduction
    ? `https://${host}`
    : `http://${host}`

  if (isDirectToHome) {
    location.href = baseUrl
    return
  }

  location.href = subPageName ? `${baseUrl}/${name}/${subPageName}` : `${baseUrl}/${name}`
}
